import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DashboardComponent } from './dashboard.component';
import { PatientGroupsComponent } from './routes/patient-groups/patient-groups.component';
import { QuestionsComponent } from './routes/questions/questions.component';

const routes: Routes = [
  {
    path: '',
    component: DashboardComponent,
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'questions' },
      {
        path: 'questions',
        loadChildren: () =>
          import('./routes/questions/questions.module').then(
            (m) => m.QuestionsModule,
          ),
      },
      {
        path: 'templates',
        loadChildren: () =>
          import('./routes/templates/templates.module').then(
            (m) => m.TemplatesModule,
          ),
      },
      {
        path: 'nutritions',
        loadChildren: () =>
          import('./routes/nutritions/nutritions.module').then(
            (m) => m.NutritionsModule,
          ),
      },
      {
        path: 'documents',
        component: QuestionsComponent,
      },
      {
        path: 'trackers',
        loadChildren: () =>
          import('./routes/custom-trackers/custom-trackers.module').then(
            (m) => m.CustomTrackersModule,
          ),
      },
      {
        path: 'groups',
        component: PatientGroupsComponent,
      },
      {
        path: 'account',
        loadChildren: () =>
          import('./routes/account/account.module').then(
            (m) => m.AccountModule,
          ),
      },
      {
        path: 'billing',
        loadChildren: () =>
          import('./routes/billing/billing.module').then(
            (m) => m.BillingModule,
          ),
      },
      {
        path: 'billing-showcase',
        loadChildren: () =>
          import('./routes/billing-showcase/billing-showcase.module').then(
            (m) => m.BillingShowcaseModule,
          ),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DashboardRoutingModule {}
